export default function DataSecurityContent() {
  return (
    <>
      <p className="text-text-muted">Last Updated: December 29, 2025</p>

      <p className="text-text-secondary">
        This Data Security Policy outlines the technical and organisational
        measures implemented by AgileForce LTD to protect all data processed
        through the Vector Migration tool.
      </p>

      <Section title="1. Payment Security">
        <List
          items={[
            "Payments handled by PCI-compliant providers",
            "No storage of card numbers or CVV",
            "Encrypted payment metadata only",
          ]}
        />
      </Section>

      <Section title="2. Data Classification">
        <List
          items={[
            "Personal Data",
            "Customer Operational Data",
            "System Logs and Metadata",
          ]}
        />
      </Section>

      <Section title="3. Access Controls">
        <List
          items={[
            "Role-based access control (RBAC)",
            "Least privilege principle",
            "Multi-factor authentication",
          ]}
        />
      </Section>

      <Section title="4. Encryption">
        <List
          items={[
            "TLS encryption in transit",
            "AES-256 encryption at rest",
          ]}
        />
      </Section>

      <Section title="5. Incident Response">
        <List
          items={[
            "Incident identification",
            "Containment and remediation",
            "User notification when required",
          ]}
        />
      </Section>

      <Section title="Contact">
        <p className="text-text-secondary">
          AgileForce LTD <br />
          Email: admin@agileforce.co.uk
        </p>
      </Section>
    </>
  );
}

/* ---------- helpers ---------- */

function Section({ title, children }) {
  return (
    <div className="space-y-2">
      <h3 className="font-semibold text-text-primary">{title}</h3>
      {children}
    </div>
  );
}

function List({ items }) {
  return (
    <ul className="list-disc list-inside space-y-1 text-text-secondary">
      {items.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ul>
  );
}